import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_LANGUAGES } from '../action-types'

const cleanupCommonFetchLanguages = createAction(COMMON_FETCH_LANGUAGES.CLEANUP)

export default cleanupCommonFetchLanguages
